import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { expVal } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceSuggestionsRoute = ({ params: { spaceKey } }: RouteMatch) => {
	if (!expVal('confluence_space_organizer', 'isEnabled', false)) {
		return <NotFound />;
	}

	return (
		<SpaceBase>
			<div>Space Suggestions for {spaceKey}</div>
		</SpaceBase>
	);
};

SpaceSuggestionsRoute.NAVIGATION_PARAMS = ({ name, params: { spaceKey } }: RouteMatch) => {
	if (!expVal('confluence_space_organizer', 'isEnabled', false)) {
		return false;
	}

	return {
		Screen: {
			screenEvent: {
				name: 'spaceSuggestionsScreen',
				id: spaceKey,
			},
			pageState: {
				routeName: name,
				spaceKey,
			},
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
			disableMinWidth: true,
		},
	};
};
